import React, { useEffect } from 'react';
import { CircularProgress } from '@material-ui/core'
import { useHistory } from 'react-router'

// Logo
import logo_trans from '../../assets/logo_trans.png';

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'

export default function SplashscreenComponent() {

    const history = useHistory()

    function checkedLogedIn() {
        setTimeout(() => {
            firebase.auth().onAuthStateChanged((user) => {
                if(user){
                    history.replace('/home')
                } else {
                    history.replace('/login')
                }
            })
        }, 1000);
    }

    useEffect(() => {
        checkedLogedIn()
    }, [])

    return(
        <div className='container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}} >
            <img src={logo_trans} style={{ height: '40%', width: '40%', marginTop: '10%'}} alt='This is a logo' ></img>
            <CircularProgress color='inherit' style={{ color: '#FB3D44', marginTop: 25 }} />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/splashscreen/SplashscreenComponent.js